// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1zFkV","colMaxWidth":"Table_colMaxWidth__2mdzg"};